module.exports = __webpack_public_path__ + "static/img/p2.6a310aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p2.jpg
// module id = vlXn
// module chunks = 1